import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { formatDate } from "../../config/Config";
import { Image } from "primereact/image";
import { useEffect, useRef, useState } from "react";
import PoliticalPartyRequirements from "./PoliticalPartyRequirements";
import { useContext } from "react";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import PoliticalProportional from "./PoliticalProportional";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../../services/EventService";
import PoliticalProportionalDocuments from "./PoliticalProportionalDocuments";
import ScreenLoader from "../../componets/ScreenLoader";

export default function ({ header="" }) {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    var { selectedParty, setSelectedParty } = useContext(PoliticalPartyDBContext);
    var [loading, setLoading] = useState(true);
    var [refresh, setRefresh] = useState(false);
    const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });
    var [eventsMapping, setEventsMapping] = useState([]);
    var [showAddDialog, setShowAddDialog] = useState({
        show: false,
        voterRecord: null,
        idNumber: "",
        village: null,
        delimitationID: null,
        delimitationLevelID: null,
        event: null,
        candidateOrder: "0",
        address: "",
        isEdit: false
    });

    useEffect(() => {
        //get event groups
        eventService
            .getAllEvents({
                PageIndex: 1,
                PageSize: 100000,
                IsPoliticalPaty: true,
                ActiveOnly: true,
                NationalOnly:false
            })
            .then((res) => {
                setEventsMapping(res);
                setLoading(false);
            });
    }, [selectedParty, refresh]);

    return (
        <>
            <b>
                Select Event <span style={{ color: "red" }}>*</span>
            </b>
        <ScreenLoader  visible={loading}/>
            <div className="grid ">
                <div className="md:col-6 col-12">
                    <Dropdown
                        className="w-full"
                        value={showAddDialog.event}
                        options={eventsMapping}
                        optionLabel="name"
                        onChange={(e) => {
                            setShowAddDialog({ ...showAddDialog, event: e.value });
                        }}
                    />
                </div>
            </div>
            <TabView>
                <TabPanel header={"Party List"}>
                    <PoliticalProportional setDelimitation={setDelimitation} delimitation={delimitation} showAddDialog={showAddDialog} setShowAddDialog={setShowAddDialog} />
                </TabPanel>
                <TabPanel header={"Party Documents"}>
                    <PoliticalProportionalDocuments delimitation={delimitation} showAddDialog={showAddDialog} setShowAddDialog={setShowAddDialog} />
                </TabPanel>
            </TabView>

        </>
    );
}


